import { Fragment } from 'react';
import MuiTypography from '@mui/material/Typography';
import { Stack, Box } from '@mui/system';
import dayjs from 'dayjs';
import CalendarIcon from '@mui/icons-material/CalendarMonth';
import { Tooltip, Avatar, Checkbox } from '@mui/material';
import { departmentIcons, departmentColors } from '../../../module/yachtDashboard/conf/Data.conf';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import { green, red, grey } from '@mui/material/colors';
import TableCellEdit from '../../../components/table/components/TableCellEdit.component';
import SelectCustom from '../../../components/form/components/SelectCustom.component';
import { Grid } from '@mui/material';
import handover from '..';
import { API } from '../api';
import RectangleChip from '../../../components/common/RectangleChip.component';
import { TypeOptions } from './Create.conf';
import * as yup from 'yup';
import DatePicker from '../../../components/form/components/DatePicker.component';

const StatusOptions = [
  { id: 'OPEN', label: 'OPEN' },
  { id: 'CLOSED', label: 'CLOSED' },
];

export const ListConf = {
  initialState: {
    pagination: {
      page: 1,
      pageSize: 100,
    },
    sort: {
      by: 'createdAt',
      direction: 'desc',
    },
  },
  rowsPerPageOptions: [25, 50, 100],
  columns: [
    {
      id: 'checkbox_select',
      key: 'checkbox_select',
      sort_key: '',
      sortable: false,
      label: '',
      checkbox: true,
      width: 50,
      selectable: true,
    },
    {
      id: 'attributes.department',
      key: 'department',
      label: 'Department',
      width: 50,
      sortable: true,
      sort_key: 'id_department.name_department'
    },
    {
      id: 'id',
      key: 'id',
      label: 'ID',
      width: 30,
      sortable: true,
      sort_key: 'id',
      cellSx: {
        width: 30,
      }
    },
    {
      id: 'attributes.type',
      key: 'type',
      label: 'Type',
      width: 180,
      sortable: true,
      sort_key: 'type',
      cellSx: {
        width: 180,
      },
    },
    {
      id: 'attributes.users_info',
      key: 'users_info',
      label: 'Users',
      width: 100,
      sortable: true,
      sort_key: 'createdAt',
      cellSx: {
        width: 250,
      }
    },
    {
      id: 'attributes.yacht_name',
      key: 'yacht_name',
      label: 'Yacht',
      width: 150,
      sortable: true,
      sort_key: 'id_yacht.yacht_name',
      cellSx: {
        width: 100,
        whiteSpace: 'normal',
        wordBreak: 'break-word',
        overflowWrap: 'anywhere',
        verticalAlign: 'middle',
      },
    },

    {
      id: 'attributes.priority',
      key: 'priority',
      label: 'Priority',
      width: 50,
      sortable: true,
      sort_key: 'priority',
    },
    {
      id: 'attributes.status',
      key: 'status',
      label: 'Status',
      width: 50,
      sortable: true,
      sort_key: 'status',
    },
    {
      id: 'attributes.date',
      key: 'date',
      label: 'Date',
      width: 180,
      sortable: true,
      sort_key: 'date',
      cellSx: {
        width: 180,
      },
    },
    {
      id: 'attributes.handover',
      key: 'handover',
      label: 'Handover',
      width: 350,
      sortable: true,
      sort_key: 'title',
    },
    {
      id: 'attributes.notes',
      key: 'notes',
      label: 'Update',
      width: 300,
    },
    {
      id: 'attributes.assignee_user',
      key: 'assignee_user',
      label: 'Assignee',
      width: 100,
      sortable: true,
      sort_key: 'assignee_user_id.id_users_permissions_user.name',
      cellSx: {
        width: 180,
      }
    },
    {
      id: 'attributes.team',
      key: 'team',
      label: 'Team',
      width: 100,
      sortable: true,
      sort_key: 'id_team.name',
    },
  ],
  render: {
    formatHead: (key, value, { isChecked, indeterminate }) => {
      switch (key) {
        case 'checkbox_select':
          return (
            <Checkbox
              checked={isChecked || false}
              color='primary'
              indeterminate={indeterminate}
            />
          );
        case 'department':
          return null;
        default:
          return (
            <MuiTypography
              variant='body1'
              sx={{ fontWeight: 'bold', color: 'white' }}
            >
              {value?.toUpperCase?.() || value}
            </MuiTypography>
          );
      }
    },
    formatValue: (key, value, onClick, isChecked) => {
      switch (key) {
        case 'id':
          return (
            <MuiTypography
              variant='body1'
              sx={{ fontWeight: 'bold' }}
              onClick={onClick}
            >
              {value || '-'}
            </MuiTypography>
          );
        case 'type': {
          const ticketType = value?.type;
          const isClosed = value?.status === 'CLOSED';
          const typeTicket = ticketType ? (
            <RectangleChip
              value={ticketType.toUpperCase()}
              backgroundColor="#009ab6"
              color="#fff"
              width="auto"
            />
          ) : (
            <MuiTypography variant="body2">-</MuiTypography>
          )

          return (
            isClosed ? typeTicket :
              <TableCellEdit
                module={{
                  ...handover,
                  query: {
                    ...handover.query,
                    edit: { settings: API.updateTicket },
                  },
                }}
                stopPropagation={true}
                value={value}
                name="type"
                hasPermission={true}
                defaultValues={{
                  type: ticketType || '',
                }}
                form={
                  <Grid item xs={12} sm={12}>
                    <SelectCustom
                      id="type"
                      name="type"
                      label="Type"
                      options={TypeOptions}
                      required={true}
                    />
                  </Grid>
                }
              >
                {typeTicket}
              </TableCellEdit>
          );
        }
        case 'users_info': {
          const createdAt = value?.createdAt;
          const createdBy = value?.created_by_user || '-';
          const closedBy = value?.closed_by_user || '-';
          const status = value?.status;

          return (
            <Stack spacing={0.5} onClick={onClick}>
              <Stack direction='row' spacing={1} alignItems='center'>
                <CalendarIcon sx={{ fontSize: 16 }} />
                <MuiTypography variant='body2'>
                  {createdAt ? dayjs(createdAt).format('DD/MM/YYYY HH:mm') : '-'}
                </MuiTypography>
              </Stack>

              <MuiTypography variant='caption' sx={{ color: 'text.secondary' }}>
                {`Created by: ${createdBy}`}
              </MuiTypography>

              {status === 'CLOSED' && (
                <MuiTypography variant='caption' sx={{ color: 'text.secondary' }}>
                  {`Closed by: ${closedBy}`}
                </MuiTypography>
              )}
            </Stack>
          );
        }
        case 'yacht_name':
          return (

            <MuiTypography
              variant='body2'
              sx={{
                fontWeight: 'bold',
                whiteSpace: 'normal',
                wordBreak: 'break-word',
                overflowWrap: 'anywhere',
                lineHeight: 1.2,
                width: '100%',
                minWidth: 0,
              }}
            >
              {value || '-'}
            </MuiTypography>

          );
        case 'assignee_user':
          return (
            <MuiTypography
              variant='body2'
              onClick={onClick}
              sx={{
                whiteSpace: 'normal',
                wordBreak: 'break-word',
                overflowWrap: 'anywhere',
                lineHeight: 1.2,
              }}
            >
              {value || '-'}
            </MuiTypography>
          );
        case 'priority':
          return (
            <Stack direction='row' spacing={1} alignItems='center' onClick={onClick}>
              {value === 'URGENT' ? (
                <Tooltip title="URGENT">
                  <PriorityHighIcon sx={{ color: red[500] }} />
                </Tooltip>
              ) : value === 'MEDIUM' ? (
                <Tooltip title="MEDIUM">
                  <PriorityHighIcon sx={{ color: '#f5b400' }} />
                </Tooltip>
              ) : value === 'LOW' ? (
                <Tooltip title="LOW">
                  <PriorityHighIcon sx={{ color: green[600] }} />
                </Tooltip>
              ) : (
                <MuiTypography variant='body1'>-</MuiTypography>
              )}
            </Stack>
          );
        case 'status':
          return (
            value?.status === 'CLOSED' ?
              <Box display='flex' alignItems='center' onClick={onClick}>
                <Tooltip title="CLOSED">
                  <CheckCircleIcon sx={{ color: green[500] }} />
                </Tooltip>
              </Box>
              :
              <TableCellEdit
                module={{
                  ...handover,
                  query: {
                    ...handover.query,
                    edit: { settings: API.updateTicket },
                  },
                }}
                stopPropagation={true}
                value={value}
                name={'status'}
                hasPermission={value?.status === 'OPEN'}
                defaultValues={{
                  status: value?.status || '',
                }}
                form={
                  <Grid item xs={12} sm={12}>
                    <SelectCustom
                      id='status'
                      name='status'
                      label='Status'
                      options={StatusOptions}
                      required={true}
                    />
                  </Grid>
                }
              >
                <Tooltip title='OPEN'>
                  <CancelIcon sx={{ color: red[500] }} />
                </Tooltip>
              </TableCellEdit>
          );

        case 'department': {
          const backgroundColor = departmentColors?.[value] || '#8CB9D4';
          const icon = departmentIcons?.[value] || value?.charAt?.(0) || '-';

          return value ? (
            <Box display='flex' alignItems='center' onClick={onClick}>
              <Tooltip title={value}>
                <Avatar
                  sx={{
                    bgcolor: backgroundColor,
                    color: 'white',
                    width: 32,
                    height: 32,
                    fontSize: '0.95rem',
                    fontWeight: 'bold',
                  }}
                >
                  {icon}
                </Avatar>
              </Tooltip>
            </Box>
          ) : (
            <MuiTypography variant='body1' onClick={onClick}>
              -
            </MuiTypography>
          );
        }

        case 'team':
          return (
            <MuiTypography variant='body2' onClick={onClick}>
              {value || '-'}
            </MuiTypography>
          );
        case 'handover':
          return (
            <Box
              pb={2}
              pt={1}
              onClick={onClick}
              sx={{
                maxWidth: 320,
              }}
            >
              <MuiTypography
                variant='body2'
                sx={{
                  fontWeight: 600,
                  mb: 0.5,
                  display: '-webkit-box',
                  WebkitLineClamp: 3,
                  WebkitBoxOrient: 'vertical',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'normal',
                  wordBreak: 'break-word',
                }}
              >
                {value?.title || '-'}
              </MuiTypography>

              <MuiTypography
                variant='body2'
                sx={{
                  color: 'text.secondary',
                  display: '-webkit-box',
                  WebkitLineClamp: 3,
                  WebkitBoxOrient: 'vertical',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'normal',
                  wordBreak: 'break-word',
                }}
              >
                {value?.description || '-'}
              </MuiTypography>
            </Box>
          );
        case 'notes': {
          const notes = value || [];
          const previewNotes = notes.slice(-3).reverse();
          const hiddenCount = notes.length - 3;

          if (!notes.length) {
            return (
              <MuiTypography variant='body2' onClick={onClick}>
                -
              </MuiTypography>
            );
          }

          return (
            <Fragment>
              <Stack
                spacing={1}
                onClick={onClick}
                pb={1}
                pt={1}
                sx={{
                  maxWidth: 320,
                }}
              >
                {previewNotes.map((note, index) => (
                  <Box
                    key={`${note?.created_at_note || 'note'}-${index}`}
                    sx={{
                      pb: 0.75,
                      borderBottom:
                        index < previewNotes.length - 1 ? '1px solid #e0e0e0' : 'none',
                    }}
                  >
                    <MuiTypography
                      variant='body2'
                      sx={{
                        fontWeight: 500,
                        display: '-webkit-box',
                        WebkitLineClamp: 3,
                        WebkitBoxOrient: 'vertical',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'normal',
                        wordBreak: 'break-word',
                      }}
                    >
                      {note?.comment || '-'}
                    </MuiTypography>

                    <MuiTypography
                      variant='caption'
                      sx={{
                        color: 'text.secondary',
                        display: 'block',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                      }}
                    >
                      {note?.created_at_note
                        ? `${dayjs(note.created_at_note).format('DD/MM/YYYY HH:mm')} - ${note?.user_name || '-'}`
                        : `- ${note?.user_name || '-'}`
                      }
                    </MuiTypography>
                  </Box>
                ))}
              </Stack>

              {notes.length > 3 && (
                <Box pb={1}>
                  <Tooltip title={`${hiddenCount} more update${hiddenCount > 1 ? 's' : ''}`}>
                    <Box
                      sx={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        px: 1,
                        py: 0.25,
                        borderRadius: 10,
                        backgroundColor: grey[200],
                        color: 'text.secondary',
                        fontSize: '0.75rem',
                        fontWeight: 600,
                        lineHeight: 1.2,
                      }}
                    >
                      +{hiddenCount}
                    </Box>
                  </Tooltip>
                </Box>
              )}
            </Fragment>
          );
        }
        case 'checkbox_select':
          return (
            <Checkbox
              checked={isChecked || false}
              color='primary'
              disabled={!onClick}
            />
          );


        case 'date':
          return (
            <TableCellEdit
              module={{
                ...handover,
                query: {
                  ...handover.query,
                  edit: { settings: API.updateTicket },
                },
              }}
              value={value}
              name={'date'}
              stopPropagation={true}
              defaultValues={{
                date: value.date,
              }}
              schema={yup.object({
                date: yup.string().nullable()
                  .test(
                    "valid-date",
                    "Invalid date",
                    (value) => {
                      if (!value) return true;
                      return dayjs(value).isValid();
                    }
                  ),
              })}
              form={
                <DatePicker
                  name={'date'}
                  value={value.date}
                />
              }
            >
              <Stack direction={'row'} spacing={1} alignItems={'center'}>
                <CalendarIcon color='action' />
                <MuiTypography
                  sx={{ fontWeight: 'bold', height: 1 }}
                  variant='body1'
                  onClick={onClick}
                >
                  {value?.date
                    ? dayjs(value.date).format(
                      'DD-MM-YYYY'
                    )
                    : '-'}
                </MuiTypography>
              </Stack>
            </TableCellEdit>
          );

        default:
          return (
            <MuiTypography variant='body1' onClick={onClick}>
              {value || '-'}
            </MuiTypography>
          );
      }
    },
  },
};